export const ru = {
  // Navigation
  documentList: 'Список Документов',
  uploadDocument: 'Загрузить Документ',
  contactUs: 'Связаться с Нами',
  profile: 'Профиль',
  login: 'Войти',
  logout: 'Выйти',
  aboutUs: 'О Нас',
  apiReference: 'Справочник API',
  integration: 'Интеграция',
  navWorkspace: 'Рабочая область',
  navResources: 'Ресурсы',
  navAccount: 'Аккаунт',
  navBackToDocuments: 'К списку документов',
  menu: 'Меню',

  // Common
  version: 'Версия',
  language: 'Язык',

  // Upload Document
  stepSelectOrganisation: 'Выберите организацию',
  step2: 'Подписанты',
  step3: 'Информация о Документе',
  step4: 'Загрузить',
  documentTitle: 'Название Документа',
  moreDocumentDetails: 'Дополнительные сведения',
  hideDocumentDetails: 'Скрыть сведения',
  uploadOperationIdLabel: 'Номер операции / внутр. ссылка',
  uploadOperationIdPlaceholder: 'напр. договор, заказ',
  uploadOperationIdHint: 'Необязательно. Ваш внутренний номер для этой подписи.',
  description: 'Описание',
  expireDate: 'Дата Истечения',
  summary: 'Резюме',
  addSigner: 'Добавить Подписанта',
  addMeAsSigner: 'Добавить меня как подписанта',
  alreadyAddedAsSigner: 'Вы уже указаны в списке подписантов.',
  addMeAsSignerNoEmail: 'В профиле не указан адрес электронной почты.',
  addMeAsSignerPromo: 'Подписываете только себя? Заполните данные одной кнопкой.',
  uploadStepValidationIntro: 'Заполните выделенные поля, чтобы продолжить.',
  uploadSignerOptionalSection: 'Контакты и ID (необязательно)',
  uploadFinOptionalHint: 'Оставьте FIN пустым, если не нужен. Если заполняете — 7 символов.',
  uploadMoreSignerTin: 'TIN / VOEN',
  uploadHideSignerTin: 'Скрыть TIN',
  uploadTinOptionalHint: 'Необязательно. Если заполняете — 10 цифр.',
  uploadUnsavedLeaveWarning: 'Есть несохранённый прогресс загрузки. Всё равно покинуть страницу?',
  uploadOptionalSuffix: 'необязательно',
  signerLabel: 'Подписант',
  signerName: 'Имя',
  signerSurname: 'Фамилия',
  signerEmail: 'Электронная Почта',
  signerPhone: 'Телефон',
  signerRole: 'Роль',
  roleSigner: 'Подписант',
  roleVisa: 'Виза',
  delete: 'Удалить',
  next: 'Далее',
  back: 'Назад',
  submit: 'Отправить',
  cancel: 'Отмена',
  
  // Document List
  documents: 'Документы',
  noDocuments: 'Нет документов',
  
  // Profile
  profileTitle: 'Профиль',
  name: 'Имя',
  surname: 'Фамилия',
  email: 'Электронная Почта',
  phone: 'Телефон',
  save: 'Сохранить',

  // Login/Register
  emailLabel: 'Электронная Почта',
  password: 'Пароль',
  rememberMe: 'Запомнить меня',
  forgotPassword: 'Забыли пароль?',
  username: 'Имя пользователя',
  usernameRequired: 'Укажите имя пользователя',
  invalidUsernameFormat: '2–64 символа: буквы, цифры, точка, подчёркивание или дефис',
  usernameHelper: 'Только буквы, цифры, . _ -',
  register: 'Регистрация',
  alreadyHaveAccount: 'Уже есть аккаунт?',
  dontHaveAccount: 'Нет аккаунта?',
  
  // Errors and Messages
  required: 'Это поле обязательно',
  invalidEmail: 'Неверный адрес электронной почты',
  invalidPhone: 'Неверный номер телефона',
  nameRequired: 'Имя обязательно',
  surnameRequired: 'Фамилия обязательна',
  emailRequired: 'Электронная почта обязательна',
  passwordRequired: 'Пароль обязателен',
  finRequired: 'FIN код обязателен',
  phoneRequired: 'Номер телефона обязателен',
  titleRequired: 'Название обязательно',
  expireDateRequired: 'Дата истечения обязательна',
  invalidEmailFormat: 'Неверный формат электронной почты',
  invalidPhoneFormat: 'Неверный формат номера телефона',
  invalidPhoneLength: 'Неверный номер телефона (используйте цифры, опционально +, длина 7-15)',
  passwordMinLength: 'Пароль должен содержать не менее 6 символов',
  passwordsDoNotMatch: 'Пароли не совпадают',
  finCodeLength: 'FIN код должен содержать 7 символов',
  tinCodeLength: 'TIN код должен содержать 10 цифр',
  selectOrganisation: 'Пожалуйста, выберите организацию',
  addAtLeastOneSigner: 'Пожалуйста, добавьте хотя бы одного подписанта',
  selectFile: 'Пожалуйста, выберите PDF-файл для загрузки.',
  selectPdfFile: 'Разрешены только файлы PDF. Пожалуйста, выберите файл PDF.',
  organisationNotSelected: 'Организация не выбрана. Пожалуйста, вернитесь назад и выберите организацию.',
  uploadFailed: 'Не удалось загрузить и отправить информацию о документе. Пожалуйста, попробуйте снова.',
  loginFailed: 'Вход не выполнен. Пожалуйста, попробуйте снова.',  uploadInProgress: 'Идёт загрузка...',
  uploadInProgressHint: 'Пожалуйста, подождите, пока документ загружается и отправка завершается.',
  uploading: 'Загрузка...',

  registrationFailed: 'Регистрация не выполнена. Пожалуйста, попробуйте снова.',
  
  // Login/Register Extended
  signIn: 'Войти',
  signUp: 'Регистрация',
  signingIn: 'Вход...',
  creatingAccount: 'Создание аккаунта...',
  signInToAccount: 'Войдите в свой аккаунт mySign.az',
  createAccount: 'Создайте свой аккаунт mySign.az',
  keepMeLoggedIn: 'Запомнить меня',
  emailAddress: 'Адрес Электронной Почты',
  confirmPassword: 'Подтвердите Пароль',
  phoneNumber: 'Номер Телефона',
  finCode: 'FIN Код',
  finCodeHelper: '7 символов',

  recoverPasswordTitle: 'Восстановление пароля',
  recoverPasswordDescription: 'Укажите email — мы отправим ссылку для сброса пароля.',
  sendResetLink: 'Отправить ссылку',
  sendingResetLink: 'Отправка…',
  resetEmailSent:
    'Если аккаунт существует, вы получите инструкции на почту. Проверьте входящие.',
  resetPasswordTitle: 'Новый пароль',
  resetPasswordDescription: 'Придумайте новый пароль для аккаунта.',
  newPassword: 'Новый пароль',
  setNewPassword: 'Обновить пароль',
  updatingPassword: 'Обновление…',
  backToSignIn: 'Назад ко входу',
  invalidResetLink: 'Ссылка недействительна или неполная. Запросите новую.',
  passwordResetSuccess: 'Пароль обновлён. Можно войти.',
  passwordResetFailed: 'Не удалось сбросить пароль. Ссылка могла истечь.',
  requestPasswordResetFailed: 'Не удалось отправить письмо. Попробуйте снова.',
  
  confirmEmailTitle: 'Подтверждение email',
  confirmingEmail: 'Подтверждаем ваш email...',
  confirmEmailSuccess: 'Спасибо за подтверждение email. Теперь вы можете войти.',
  confirmEmailSuccessHint: 'Email подтверждён. Перенаправляем на страницу входа...',
  confirmEmailFailed: 'Не удалось подтвердить email. Ссылка может быть недействительной или просроченной.',
  confirmEmailFailedHint: 'Попробуйте ссылку снова или запросите новое письмо для подтверждения.',
  invalidConfirmEmailLink: 'Ссылка для подтверждения недействительна или неполная.',

  // Document List Extended
  documentListTitle: 'Список Документов',
  viewAllDocuments: 'Просмотрите все ваши документы',
  noDocumentsFound: 'Документы Не Найдены',
  noDocumentsYet: 'У вас пока нет документов.',
  pleaseLoginToView: 'Пожалуйста, войдите, чтобы просмотреть ваши документы.',
  failedToLoadDocuments: 'Не удалось загрузить документы. Пожалуйста, попробуйте снова.',
  title: 'Название',
  expirationDate: 'Дата Истечения',
  status: 'Статус',
  actions: 'Действия',
  view: 'Просмотр',
  operation: 'Операция',
  unknown: 'Неизвестно',
  untitledDocument: 'Документ Без Названия',
  documentFilters: 'Фильтры',
  signingStatusFilter: 'Статус подписания',
  signStatusAll: 'Все',
  signStatusSigned: 'Завершён',
  signStatusPending: 'В процессе',
  createdFromFilter: 'Создано с',
  expiresBeforeFilter: 'Истекает не позже',
  operationIdFilter: 'ID операции',
  operationIdFilterPlaceholder: 'Необязательный ID операции',
  applyFilters: 'Применить фильтры',
  resetFilters: 'Сбросить',
  showFilters: 'Показать фильтры',
  hideFilters: 'Скрыть фильтры',

  // Profile Extended
  myProfile: 'Мой Профиль',
  viewPersonalInfo: 'Просмотрите вашу личную информацию',
  pleaseLoginToViewProfile: 'Пожалуйста, войдите, чтобы просмотреть ваш профиль.',
  failedToLoadProfile: 'Не удалось загрузить профиль',

  // Footer
  footerText: 'mySign, создано с заботой',
  footerIn: 'в Азербайджане © 2026 -',
  footerCopyright: '© 2026 mySign.az. All rights reserved.',
  privacyPolicy: 'Политика Конфиденциальности',
  termsOfService: 'Условия использования',
  
  // Upload Document Extended
  review: 'Проверка',
  signers: 'Подписанты',
  tinCode: 'TIN Код',
  selectStorageOrganisation: 'Выберите Организацию Хранилища',
  chooseStorageOrganisation: 'Выберите организацию хранилища, куда будет загружен ваш документ.',
  noOrganisationsAvailable: 'Организации недоступны. Пожалуйста, свяжитесь со службой поддержки.',
  endpoint: 'Endpoint',
  selectDocument: 'Выбрать Документ',
  selectDocumentHint: 'Выберите PDF-файл на вашем компьютере.',
  selectedFile: 'Выбранный файл',
  documentSuccessfullyUploaded: 'Документ Успешно Загружен!',
  thankYouMessage: 'Спасибо за использование нашего сервиса. Ваш документ загружен, и подписанты будут уведомлены.',
  goToDocumentList: 'Перейти к списку документов',
  signingLink: 'Ссылка для Подписания',
  signingLinkCopied: 'Ссылка скопирована',
  failedToLoadOrganisations: 'Не удалось загрузить организации. Пожалуйста, обновите страницу.',
  
  // Document Page
  document: 'Документ',
  validityPeriod: 'Период Действия',
  from: 'С',
  to: 'По',
  organisation: 'Организация',
  notAvailable: 'Недоступно',
  operationId: 'ID Операции',
  signed: 'Подписан',
  pending: 'В Ожидании',
  documentStatusDone: 'Готово',
  documentStatusInProgress: 'В процессе',
  type: 'Тип',
  signingParties: 'Подписывающие Стороны',
  signingPartyStatusExpired: 'Истёк срок',
  signingPartyStatusRejected: 'Отклонено',
  signingPartyStatusReleased: 'Выпущено',
  finLabel: 'FIN',
  noDocumentInfo: 'Информация о документе недоступна',
  signWithSima: 'Подписать через Sima',
  release: 'Release',
  confirm: 'Подтвердить',
  releaseDialogMessage: 'Вы согласовываете документ.',
  rejectDialogMessage: 'Вы отказываетесь от запроса на подписание этого документа.',
  releaseDialogConfirm: 'Release',
  rejectDialogConfirm: 'Отказаться',
  failedToUpdateSignStatus: 'Не удалось обновить статус подписания. Пожалуйста, попробуйте снова.',
  reject: 'Отклонить',
  documentTabDetails: 'Детали',
  documentTabDocument: 'Документ',
  documentTabListLabel: 'Разделы документа',
  documentActions: 'Действия',
  documentActionsExpand: 'Показать действия с документом',
  documentActionsCollapse: 'Скрыть действия с документом',
  documentDetailsResize: 'Изменить размер панели деталей документа',
  documentMoreDetails: 'Подробнее',
  pdfRenderError: 'Не удалось отобразить PDF в браузере. Попробуйте открыть во внешнем приложении.',
  openPdfInBrowser: 'Открыть в браузере',
  downloadDocument: 'Скачать',
  simaSignModalTitle: 'Подписать через SIMA',
  simaScanQrDesktop: 'Отсканируйте QR-код приложением SIMA',
  simaScanQrMobile: 'Или отсканируйте QR-код SIMA на другом устройстве',
  simaOpenSignerApp: 'Открыть приложение для подписания',
  simaEnlargeQr: 'Увеличить QR-код',
  simaEnlargedQr: 'Увеличенный QR-код',
  simaTapQrToZoom: 'Нажмите, чтобы увеличить',
  simaTapToCloseQr: 'Нажмите в любом месте, чтобы закрыть',
  simaSignWaiting: 'Ожидание подписи…',
  simaSignThanks: 'Спасибо. Документ подписан.',
  openDocument: 'Открыть Документ',
  closeDocumentViewer: 'Закрыть Просмотр Документа',
  openDocumentViewer: 'Открыть Просмотр Документа',
  noDocumentLoaded: 'Предпросмотр не загружен. Нажмите «Показать файл», чтобы получить документ с сервера.',
  loadDocument: 'Загрузить Документ',
  displayFile: 'Показать файл',
  rejectDocument: 'Отклонить Документ',
  rejectDocumentReason: 'Пожалуйста, укажите причину отклонения этого документа.',
  rejectionReason: 'Причина Отклонения',
  documentGUIDNotFound: 'GUID документа не найден.',
  failedToFetchDocumentInfo: 'Не удалось получить информацию о документе',
  errorFetchingDocumentInfo: 'Ошибка при получении информации о документе. Пожалуйста, попробуйте позже.',
  signingLinkAccessDenied: 'У вас нет доступа к этой ссылке для подписания. Откройте ссылку, отправленную вам, или войдите с правильной учётной записью.',
  failedToFetchDocument: 'Не удалось получить документ',
  errorFetchingDocument: 'Ошибка при получении документа. Пожалуйста, попробуйте позже.',
  invalidResponseFormat: 'Неверный формат ответа',
  failedToInitiateSigning: 'Не удалось инициировать процесс подписания',
  documentSigningByOther: 'Документ подписывается другой стороной. Пожалуйста, попробуйте через 5 минут.',
  errorInitiatingSigning: 'Ошибка при инициировании процесса подписания. Пожалуйста, попробуйте позже.',
  signWithUsbToken: 'Подписать с помощью SIMA USB ключа',
  failedToReadCertificates: 'Не удалось прочитать сертификаты с USB токена',
  noCertificatesFound: 'Сертификаты не найдены. Пожалуйста, вставьте ваш USB токен.',
  errorReadingCertificates: 'Ошибка чтения сертификатов. Пожалуйста, убедитесь, что ваш USB токен подключен.',
  pleaseSelectCertificate: 'Пожалуйста, выберите сертификат',
  selectCertificate: 'Пожалуйста, выберите сертификат для подписания документа',
  documentNotReady: 'Информация о документе не готова. Пожалуйста, дождитесь загрузки страницы, затем подпишите.',
  documentNotReadyNoSignerId: 'Чтобы подписать по USB, откройте этот документ по своей персональной ссылке для подписания (ссылке, которая вам была отправлена). Эта страница открыта без вашего ID подписанта.',
  serialNumber: 'Серийный номер',
  sign: 'Подписать',
  missingDocumentInfo: 'Отсутствует информация о документе',
  failedToSignDocument: 'Не удалось подписать документ',
  errorSigningDocument: 'Ошибка при подписании документа',
  failedToUploadSignedDocument: 'Не удалось загрузить подписанный документ',
  errorSigningWithUsbToken: 'Ошибка при подписании документа с помощью USB токена',

  signLinkStatusLabel: 'Статус',
  signLinkStatusPending: 'Ожидается подпись',
  signLinkStatusReleased: 'Подтверждено (виза)',
  signLinkStatusUnknown: 'Неизвестный статус',
  signLinkHello: 'Здравствуйте,',
  signLinkPageTitleSigner: 'Подпишите документ',
  signLinkPageTitleVisa: 'Подтвердите документ',
  signLinkValidUntil: 'Действует до',
  signLinkSignedOn: 'Дата',
  signLinkSignCta: 'Подписать через Sima',
  signLinkVisaCta: 'Войдите, чтобы подтвердить',
  signLinkVisaNotice:
    'Это документ Visa. Войдите, чтобы открыть его в mySign и подтвердить одной кнопкой.',
  signLinkViewIntro: 'Чтобы посмотреть документ в браузере на mySign.az,',
  signLinkLoginAction: 'войдите',
  signLinkViewOr: 'или',
  signLinkRegisterAction: 'зарегистрируйтесь',
  signLinkHowToSignTitle: 'Как подписать через Sima?',
  signLinkHowToVisaTitle: 'Как подтвердить?',
  signLinkHowToStep1: 'Нажмите кнопку и откройте приложение Sima.',
  signLinkHowToStep2: 'Завершите действие в приложении. На компьютере отсканируйте QR-код.',
  signLinkHowToStep3: 'Эта страница сама покажет результат.',
  signLinkContinueInSima: 'Продолжите в Sima',
  signLinkOpenSima: 'Открыть приложение Sima',
  signLinkScanOtherDevice: 'Сканировать на другом устройстве',
  signLinkQrInstructions: 'Отсканируйте QR-код приложением Sima.',
  signLinkQrAlt: 'QR-код для Sima',
  signLinkPolling: 'Проверяем статус подписи…',
  signLinkNotFoundTitle: 'Ссылка не найдена',
  signLinkNotFoundBody: 'Эта ссылка недействительна или не существует. Откройте приглашение, которое вам отправили.',
  signLinkInvalidTitle: 'Недействительная ссылка',
  signLinkInvalidBody: 'Эта ссылка для подписания недействительна. Откройте новую ссылку-приглашение.',
  signLinkLoadError: 'Не удалось загрузить данные. Попробуйте снова.',
  signLinkRetry: 'Попробовать снова',
  signLinkLoading: 'Загрузка',
  signLinkPrivacy: 'Конфиденциальность',
  signLinkFooterNav: 'Ссылки',
  signLinkThanks: 'Спасибо.',
  signLinkCompletedSigned: 'Документ подписан.',
  signLinkCompletedReleased: 'Документ подтверждён.',
  signLinkLockGeneric: 'Документ сейчас заблокирован. Попробуйте чуть позже.',
  signLinkStartError: 'Не удалось начать подписание. Попробуйте снова.',
  signLinkBlockedHint: 'Сейчас подписать нельзя.',
  signLinkAlreadyUsed: 'Эта ссылка для подписания уже использована.',
};
